class SizeVariantDropdown extends VariantSelector {
  constructor() {
    super();
    this.property = 'size';
    this.value = false;
    this.displayValue = false;
    this.formId = this.getAttribute('form-id');
    this.unavailableText = this.getAttribute('unavailable-text');
    this.defaultLabel = this.getAttribute('default-label');
    this.options = [];
    this.wrapper = this.querySelector('.product-size-dropdown');
    this.tooltip = this.querySelector('.product-size-dropdown__tooltip');
    this.label = this.querySelector('.product-size-dropdown__label');
    this.dropdown = this.querySelector('.product-size-dropdown__select');
    this.sr = this.querySelector('.product-size-dropdown__sr');
  }


  setValue(value){
    super.setValue(value);   
    const selected = this.dropdown.querySelector(`option[value="${value}"]`);
    if (this.dropdown.value != value){
      this.dropdown.value = value;
    }
    this.updateLabel();
  }

  render() {
    const options = window.variants.getVariantData(this.property);
    let markup = `<option value="" disabled selected>${this.defaultLabel}</option>`;

    options.forEach((value, index) => {
      const selectorID = `selector-${this.property}-${index}`;

      const valueLabel = value.enabled ? value.label : `${value.label} - ${this.unavailableText}`;
      markup += `<option id="${selectorID}" value="${value.value}" name="${this.property}-option" data-disabled="${(value.enabled ? 0 : 1)}">${valueLabel}</option>`;
    });

    this.dropdown.insertAdjacentHTML('beforeend', markup);

    this.dropdown.classList.toggle('hidden', options.length === 0);

    /* Set options to enable event listener attachment. */
    this.options = [this.dropdown];

    this.dropdown.addEventListener('change', this.onValueChanged.bind(this));

    this.label.innerHTML = this.defaultLabel;
    this.updateUrls();
  }

  updateUrls(){
    // Updates the url of non available colors and clears dropdown selection when navigating a not available color variant.
    const baseUrl = `${this.getAttribute('url-root')}`;

    const options = window.variants.getVariantData("color");
    options.forEach((option) => {
      if (option.enabled) return;
      const element = document.querySelector(`[href*="${option.dynamicHandle}"]`);
      if (element){
        const color = option.label.trim().toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
        element.setAttribute('href', `${baseUrl}/${option.dynamicHandle}?&color=${color}`);
      }
    });
  }

  updateOptions(event){
    if (event.detail.property != this.property){
      const options = window.variants.getVariantData(this.property);

      for (var option in options){
        const input = this.dropdown.querySelector(`option[value="${options[option].value}"]`);

        if (input){ 
          if (options[option].enabled){
            input.innerHTML = options[option].label;
            input.setAttribute('data-disabled', 0);
          } else {
            input.innerHTML = `${options[option].label} - ${this.unavailableText}`;
            input.setAttribute('data-disabled', 1);
          }
        }
      }
      this.updateUrls();
      this.updateLabel();
    }
  }

  updateSelected(event){
    if (event.detail.property == this.property){
      this.dropdown.value = event.detail.code;
      this.updateLabel();
    }
  }

  updateLabel() {
    this.displayValue = this.dropdown.options[this.dropdown.selectedIndex].innerHTML;
    this.tooltip.dataset.acsbTooltip = `${this.property}: ${this.displayValue}`;
    this.label.innerHTML = this.displayValue;
    this.dropdown.dataset.acsbTooltip = this.displayValue;
    this.sr.dataset.innerHTML = `${this.property}: ${this.displayValue}`;
  }

  onValueChanged(event){
    this.setValue(this.dropdown.value);
    window.variants.setVariantOption(this.property, this.value);
    this.updateUrls();
  }
}

customElements.define('size-variant-dropdown', SizeVariantDropdown);
